import { FC } from "react"
import { SchedulesEdit } from "../../../../module/schedules/containers/edit"

export const SchedulesEditUserPage: FC = () => <SchedulesEdit />
